export const blockIconsDeviceWidgets = (
	<span className='material-symbols-outlined'>widgets</span>
);
